import {
  facebook,
  instagram,
  medium,
  reddit,
  telegram,
  twitter,
  youtube,
} from "../../assets/index";

export const SOCIAL_ICONS = [
  {
    id: 1,
    src: facebook,
    href: "https://www.facebook.com/VirtuaMetaverse/",
    alt: "facebook",
  },
  {
    id: 2,
    src: twitter,
    href: "https://twitter.com/Virtuametaverse",
    alt: "twitter",
  },
  {
    id: 3,
    src: instagram,
    href: "https://www.instagram.com/Virtuametaverse/",
    alt: "instagram",
  },
  {
    id: 4,
    src: reddit,
    href: "https://www.reddit.com/user/terravirtua",
    alt: "reddit",
  },
  {
    id: 5,
    src: youtube,
    href: "https://www.youtube.com/VirtuaMetaverse",
    alt: "youtube",
  },
  {
    id: 6,
    src: medium,
    href: "https://medium.com/terravirtua",
    alt: "medium",
  },
  {
    id: 7,
    src: telegram,
    href: "https://t.me/Virtuametaverse",
    alt: "telegram",
  },
];

export const showBodyOverflow = () => {
  document.body.classList.remove("overflow-hidden");
};
export const hideBodyOverflow = () => {
  document.body.classList.add("overflow-hidden");
};
